import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { FilterWidget } from '@sorare/core/src/lib/filters';

import { DropdownFilter } from 'searchCommonPlayer/DropdownFilter';
import { FavoriteFilter } from 'searchCommonPlayer/FavoriteFilter';
import { FloorPricesDropdownFilter } from 'searchCommonPlayer/FloorPricesDropdownFilter';
import { StartersFilter } from 'searchCommonPlayer/StartersFilter';

type Props = {
  dropdownFilters?: FilterWidget[];
};

export const Segment = ({ dropdownFilters = [] }: Props) => {
  const { sport } = useSportContext();
  const segments = [
    ...(sport === Sport.FOOTBALL ? [<StartersFilter key="starter" />] : []),
    <FavoriteFilter key="favorite" />,
    <FloorPricesDropdownFilter key="floor-prices" />,
    ...dropdownFilters.map(widget => (
      <DropdownFilter key={widget.key} widget={widget} />
    )),
  ];

  return <Horizontal>{segments}</Horizontal>;
};
